$(document).ready( function() {
	jQuery('a[href^="http"]').not('a[href^="'+$(location).attr('hostname')+'"]').attr('target', '_blank');
});

<!-- Additional site tag (gtag.js) - Google Analytics -->
$.getScript("https://www.googletagmanager.com/gtag/js?id=UA-139835040-1", function() {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-139835040-1', {
      'anonymize_ip': true,
      'linker': {
        'domains': ['pvsol.software']
      }
    });
});


/* I disabled the PayPal and other Payment Options from the Checkout.
 * To re-enable them go to: 
 * Settings > Online Store > Google Analytics > Additional Google Analytics Javascript
 * and delete this lines:
 * 
 * document.getElementsByClassName("alt-payment-list-container")[0].style.display = "none";
 * document.getElementsByClassName("alternative-payment-separator")[0].style.display = "none";
 * 
 * See: https://ecommerce.shopify.com/c/ecommerce-design/t/supply-theme-how-to-remove-check-out-with-paypal-button-at-the-checkout-page-274154
*/



